const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const accordion = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.accordion();
		this.customFile();
		this.putTitleValueToInput();
	},

	accordion: ()=> {
		const accordionItem = document.querySelectorAll('.js-acc-btn');
		accordionItem.forEach(accordionItem => {
			accordionItem.addEventListener('click', event => {
				const active = document.querySelector('.js-acc-btn.active');
				if(active && active !== accordionItem) {
					active.classList.toggle('active');
					active.nextElementSibling.style.maxHeight = 0;
				}
				accordionItem.classList.toggle('active');
				const el = accordionItem.nextElementSibling;
				if(accordionItem.classList.contains('active')){
					el.style.maxHeight = el.scrollHeight + 'px';
					el.parentNode.classList.add('active-item');
					setTimeout(() => {
						el.style.maxHeight = 'none';
					}, 500);
				} else {
					el.style.maxHeight = 0;
					el.parentNode.classList.remove('active-item');
				}
			});
		});
	},
	customFile: function() {
		$('.add-file').on('change', (e)=> {
			const _self = $(e.currentTarget);
			if(_self[0].files.length < 1) {
				_self.parent().siblings('.js-custom-file').text('');
				_self.parent().siblings('.js-custom-file').removeClass('show-icon');
			} else {
				const text = _self[0].files[0].name;
				_self.parent().siblings('.js-custom-file').text(text);
				_self.parents('.accordion-input--file').find('label').css({
					'top': '-15px',
					'font-size': '12px',
					'left': '0',
					'font-weight': '600',
					'color': '#29b2e7'
				});
			}
		});
	},
	putTitleValueToInput() {
		const accordionItem = $('.js-acc-btn');
		$('.accordion__item').each(
			function(index, el) {
				const activeName = $(this).find('.accordion__button-name').text();
				const inputJob = $(this).find('.title-val');
				inputJob.val(activeName);
				inputJob.attr('value', activeName);
			}
		);
	}
};

export default accordion;